import { Observable } from 'rxjs';
import { IGetGateway, ISaveGateway } from '../gateways';
import { BANNER_SCHEMA, DEFAULT_BANNER, IBanner } from '@web/dtos';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';

export class BannerGateway
  implements
    IGetGateway<null, IApiResponse<IBanner> | null>,
    ISaveGateway<IBanner, IApiResponse<IBanner> | null>
{
  private readonly restCallBuilder: RestCallBuilder<IBanner> =
    new RestCallBuilder<IBanner>(DEFAULT_BANNER);

  get(): Observable<IApiResponse<IBanner>> {
    return this.restCallBuilder
      .get('/banner/')
      .validate(API_RESPONSE_SCHEMA(BANNER_SCHEMA), 'Banner.get')
      .handleMessages()
      .build();
  }

  save(query: IBanner): Observable<IApiResponse<IBanner>> {
    return this.restCallBuilder
      .post('/banner/', query)
      .validate(API_RESPONSE_SCHEMA(BANNER_SCHEMA), 'Banner.save')
      .handleMessages()
      .build();
  }
}
